import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import App from './App'
import CPDashboard from './pages/CPDashboard'
import SalesCareHomes from './pages/SalesCareHomes'
import SalesMap from './pages/SalesMap'
import SalesAuthGuard from './auth/SalesAuthGuard'
import './styles/index.css'
import { initializeGTM } from './utils/gtm'

// Initialize Google Tag Manager (production only)
initializeGTM();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/cp_dashboard" element={<CPDashboard />} />
        <Route path="/sales_carehomes" element={
          <SalesAuthGuard>
            <SalesCareHomes />
          </SalesAuthGuard>
        } />
        <Route path="/sales_map" element={
          <SalesAuthGuard>
            <SalesMap />
          </SalesAuthGuard>
        } />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
) 